// @flow
import * as React from 'react'
import { BoldText, P } from 'ui/Typography'

type Props = {
  email: string,
}

export default class ResetPasswordInstructions extends React.Component<Props> {
  render = () => {
    return (
      <P>
        An email has been sent to <BoldText>{this.props.email}</BoldText> with instructions on how
        to reset or create a new password.
      </P>
    )
  }
}
